import { render } from "./PaymentPlanModalSectionDetails.vue?vue&type=template&id=0a552125"
import script from "./PaymentPlanModalSectionDetails.vue?vue&type=script&lang=js"
export * from "./PaymentPlanModalSectionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__